document.addEventListener('DOMContentLoaded', function () {
  const skipTargetId = 'page-content';
  const skipLink = document.querySelector(`a[href="#${skipTargetId}"]`);

  function focusSkipTarget() {
    const el = document.getElementById(skipTargetId);
    if (el) {
      el.focus({ preventScroll: true });
      el.scrollIntoView({ block: 'start', inline: 'nearest' });
    }
  }

  if (skipLink) {
    skipLink.addEventListener('click', (e) => {
      requestAnimationFrame(focusSkipTarget);
    });
  }

  if (location.hash === `#${skipTargetId}`) {
    focusSkipTarget();
  }
});